// extracted by css-extract-rspack-plugin
export default {"cls1":"BigCardBulkFollow-cls1_lfy","cls2":"BigCardBulkFollow-cls2_61N BigCardBulkFollow-cls1_lfy"};